import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './FooterSocialIcons.module.scss';
import { CatIconFacebook } from '@blocks-react/components/Icons/Facebook';
import { CatIconSocialLinkedin } from '@blocks-react/components/Icons/SocialLinkedin';
import { CatIconSocialYoutube } from '@blocks-react/components/Icons/SocailYoutube';
import { CatIconSocialInstagram } from '@blocks-react/components/Icons/SocialInstagram';
import { CatIconSocialX } from '@blocks-react/components/Icons/SocialX';
export const FooterSocialIcons = ({ socialId, socialName }) => {
    const iconMap = {
        catSocialFacebook: CatIconFacebook,
        catSocialYouTube: CatIconSocialYoutube,
        catSocialInstagram: CatIconSocialInstagram,
        catSocialLinkedIn: CatIconSocialLinkedin,
        catSocialX: CatIconSocialX,
        catSocialTwitter: CatIconSocialX,
    };
    const IconComponent = iconMap[socialId];
    return (_jsxs("div", { className: styles['footer_pcclink-list-item'], children: [IconComponent ? (_jsx(IconComponent, { className: styles['footer_pcclink-list-item__icon'], "data-testid": "footer_social_icon" })) : null, socialId === 'catSocialTwitter' ? 'X' : socialName] }));
};
